import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Components from './components'
import NavScroll from './plugins/nav-scroll'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import GAuth from 'vue-google-oauth2'
import './modules/icons'

const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_OAUTH_ID
}

Vue.config.productionTip = false

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.use(Components)
Vue.use(NavScroll)
Vue.use(GAuth, gauthOption)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
